import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { FieldType, IField } from '../models/field/field.model';

export function createFormGroup<T>(fields: IField[], initialValue: T): FormGroup {
    const data: Record<string, AbstractControl> = {};
    for (const field of fields) {
        const value: unknown = initialValue != null && (initialValue as unknown as string) !== '' ? initialValue[ field.field ] : '';
        if (field.type === FieldType.daterange) {
            const range: { start: FormControl, end: FormControl } = {
                start: new FormControl<string>(''),
                end: new FormControl<string>(''),
            };
            data[ field.field ] = new FormGroup<{ start: FormControl<string>, end: FormControl<string> }>(range);
        } else if (field.type === FieldType.checkbox) {
            data[ field.field ] = new FormControl<boolean>(value as boolean || false);
        } else {
            data[ field.field ] = new FormControl<string>(value as string);
        }

        // const validators: (ValidatorFn | AsyncValidatorFn)[] = [ ...(field.validatorFn || []) ];
        // if (field.required) {
        //     validators.push(Validators.required);
        // }
        // data[ field.field ].setAsyncValidators((field.asyncValidatorFn || []));
        // data[ field.field ].setValidators((validators || []));
        // if (field.disabled) {
        //     data[ field.field ].disable({ emitEvent: false });
        // }
    }
    return new FormGroup(data);
}
